<div class="container" [formGroup]="newsletterTemplateCreateFormGroup">
    <mat-card appearance="outlined" class="mat-component-background mat-elevation-z2">
        <mat-card-header>
            <mat-card-title> Create Newsletter Template </mat-card-title>
        </mat-card-header>
        <mat-card-content class="container-card">
            <div [ngClass]="{
                'container-content-xlarge': isXLarge(),
                'container-content-large': isLarge(),
                'container-content-medium': isMedium(),
                'container-content-small': isSmall(),
                'container-content-xsmall': isXSmall()
            }">
                <form [formGroup]="newsletterTemplateCreateFormGroup">
                    <div class="container-column">
                        <mat-form-field appearance="outline">
                            <mat-label>Name</mat-label>
                            <input matInput placeholder="Ex. My newsletter template" formControlName="name" />
                            <mat-error *ngIf="
                    newsletterTemplateCreateFormGroup.get('name').hasError('required') &&
                    newsletterTemplateCreateFormGroup.get('name').touched
                  ">
                                <span>Name is required</span>
                            </mat-error>
                            <mat-error *ngIf="
                    newsletterTemplateCreateFormGroup.get('name').hasError('minlength') &&
                    newsletterTemplateCreateFormGroup.get('name').touched
                  ">
                                <span>Name should have a minimum length of
                                    {{ minNameLength }}</span>
                            </mat-error>
                            <mat-error *ngIf="
                    newsletterTemplateCreateFormGroup.get('name').hasError('maxlength') &&
                    newsletterTemplateCreateFormGroup.get('name').touched
                  ">
                                <span>Name can have a maximum length of
                                    {{ maxNameLength }}</span>
                            </mat-error>
                        </mat-form-field>
                    </div>
                </form>
            </div>
        </mat-card-content>
    </mat-card>
    <div id="gjs" #gjs></div>
</div>